import React from 'react';
import styled from 'styled-components';
import { NewTabLink } from '../common';

export default () => (
  <Footer>
    © CzechBased. A project curated by &nbsp;
    <FooterNewTabLink href="https://www.phung.io/">Tuan Phung</FooterNewTabLink>.
  </Footer>
);

const Footer = styled.div`
  color: #919ba2;
  font-size: 14px;
  padding: 96px 0;
  text-align: center;
  background: #f2f4f8;
`;

const FooterNewTabLink = styled(NewTabLink)`
  color: #575d61;
  font-weight: bold;
`;
